module.exports = __webpack_public_path__ + "img/w1.e48a8b94.svg";